export default {

  methods: {
    
    draw_Timeline() {    

      let Timeline = this.canvasChart
      .append('g')
      .attr('transform', `translate(${0}, ${this.chart.height + .5})`)
      .style('font-family', 'roboto')

      // Week 
       Timeline
      .selectAll('line1')
      .data(this.timeline.week)
      .enter()
      .append('line')
      .attr('x1', d => d.sx).attr('y1', 0)
      .attr('x2', d => d.sx).attr('y2', (d,i)=> i==0 ? 0 : 2)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      Timeline
      .selectAll('text2')
      .data(this.timeline.week)
      .enter()
      .append('text')
      .attr('x', d=> d.mx).attr('y', 9)
      .attr('font-size', 8.5).attr('fill', '#757575')
      .attr('text-anchor', 'middle')
      .text(d => d.name)


      // Month 
      Timeline
      .selectAll('line2')
      .data(this.timeline.month)
      .enter()
      .append('line')
      .attr('x1', d => d.sx).attr('y1', 0)
      .attr('x2', d => d.sx).attr('y2', (d,i)=> i==0 ? 0 : 18)
      .attr('stroke', '#bcbcbc').attr('stroke-width', .5)

      Timeline
      .selectAll('text2')
      .data(this.timeline.month)
      .enter()
      .append('text')
      .attr('x', d=> d.mx).attr('y', 18)
      .attr('font-size', 9).attr('fill', '#333')
      .attr('text-anchor', 'middle')
      .text(d => d.name)
  
    }, 

  }
}
